<template>
  <v-select
    v-bind="$attrs"
    v-on="$listeners"
    :items="countries"
    item-text="name"
    item-value="name"
  >
  </v-select>
</template>

<script>
import { countries } from 'countries-list'

const _countries = Object.entries(countries)
  .map(([value, props]) => ({ value, ...props }))

export default {
  name: 'CountrySelect',

  data: () => ({
    countries: _countries
  })
}
</script>
